import React, { useState } from "react";
import Info from "../components/info";
import NutritionalTable from "../components/nutritionalTable";
import AmbientalTable from "../components/ambientalTable";

const europeanLanguages = {
    it: "Italiano", en: "English", de: "Deutsch", es: "Español"
};
const translations = {
    it: {
        title: "Etichetta Alimentare",
        not_found: "Prodotto non trovato",
        ingredients: "Ingredienti",
        nutrition: "Dichiarazione nutrizionale",
        environment: "Etichetta ambientale",
        category: "Categoria",
        material: "Materiale",
        code: "Codice Ambientale",
        waste: "Destinazione Rifiuto",
        affinamento: "Acciaio",
        regione: "Lombardia",
        paese: "Italia"
    },
    en: {
        title: "Food Label",
        not_found: "Product not found",
        ingredients: "Ingredients",
        nutrition: "Nutritional Declaration",
        environment: "Environmental Label",
        category: "Category",
        material: "Material",
        code: "Environmental Code",
        waste: "Waste Destination",
        affinamento: "Steel",
        regione: "Lombardy",
        paese: "Italy"
    },
    de: {
        title: "Lebensmittelkennzeichnung",
        not_found: "Produkt nicht gefunden",
        ingredients: "Zutaten",
        nutrition: "Nährwertdeklaration",
        environment: "Umweltkennzeichnung",
        category: "Kategorie",
        material: "Material",
        code: "Umweltcode",
        waste: "Abfallentsorgung",
        affinamento: "Stahl",
        regione: "Lombardei",
        paese: "Italien"
    },
    es: {
        title: "Etiqueta Alimentaria",
        not_found: "Producto no encontrado",
        ingredients: "Ingredientes",
        nutrition: "Declaración nutricional",
        environment: "Etiqueta medioambiental",
        category: "Categoría",
        material: "Material",
        code: "Código Medioambiental",
        waste: "Destino del residuo",
        affinamento: "Acero",
        regione: "Lombardía",
        paese: "Italia"
    }
};

const productData = {
    name: "Il Biunt",
    image: "../../biunt.png",
    price: 12.99,
    denominazione: "Terre Lariane IGT Sauvignon",
    vitigno: "100% Sauvignon blanc",
    annata: "2024",
    gradazione: 12.5,
    aromi: "Frutti rossi, spezie, vaniglia",
    affinamento: "Acciaio",
    regione: "Lombardia",
    paese: "Italia",
    size: 0.75,
    ingredients: {
        it: "Uva, Conservanti e antiossidanti: metabisolfito di potassio (E224), acido L-ascorbico (E300), Agenti stabilizzanti: gomma arabica (E414), poliaspartato di potassio (E 456), acido fumarico (E297), Gas e gas d'imballaggio: azoto (E941).",
        en: "Grapes, Preservatives and antioxidants: potassium metabisulfite (E224), L-ascorbic acid (E300), Stabilizing agents: gum arabic (E414), potassium polyaspartate (E456), fumaric acid (E297), Gases and packaging gases: nitrogen (E941).",
        de: "Trauben, Konservierungsmittel und Antioxidantien: Kaliummetabisulfit (E224), L-Ascorbinsäure (E300), Stabilisatoren: Gummi arabicum (E414), Kaliumpolyaspartat (E456), Fumarsäure (E297), Gase und Packgase: Stickstoff (E941).",
        es: "Uvas, Conservantes y antioxidantes: metabisulfito de potasio (E224), ácido L-ascórbico (E300), Agentes estabilizantes: goma arábiga (E414), poliaspartato de potasio (E456), ácido fumárico (E297), Gases y gases de envasado: nitrógeno (E941)."
    },
    nutritionalValues: {
        energy: "302 kJ/ 73 kcal",
        fat: "0 g",
        di_cui_saturi: "0 g",
        carbohydrates: "0,8 g",
        di_cui_zuccheri: "0 g",
        protein: "0 g",
        sale: "0 g"
    },
    environmentalInfo: {
        it: [
            { category: "Bottiglia", material: "Vetro", code: "GL70", waste: "Raccolta vetro" },
            { category: "Tappo", material: "Sughero", code: "FOR51", waste: "Organico" },
            { category: "Capsula", material: "Alluminio", code: "ALU41", waste: "Raccolta metalli" },
            { category: "Gabbietta", material: "Ferro", code: "FE40", waste: "Raccolta metalli" }
        ],
        en: [
            { category: "Bottle", material: "Glass", code: "GL70", waste: "Glass collection" },
            { category: "Cork", material: "Cork", code: "FOR51", waste: "Organic" },
            { category: "Cap", material: "Aluminum", code: "ALU41", waste: "Metal collection" },
            { category: "Wire cage", material: "Iron", code: "FE40", waste: "Metal collection" }
        ],
        de: [
            { category: "Flasche", material: "Glas", code: "GL70", waste: "Glasentsorgung" },
            { category: "Korken", material: "Kork", code: "FOR51", waste: "Organisch" },
            { category: "Kapsel", material: "Aluminium", code: "ALU41", waste: "Metallentsorgung" },
            { category: "Drahtkorb", material: "Eisen", code: "FE40", waste: "Metallentsorgung" }
        ],
        es: [
            { category: "Botella", material: "Vidrio", code: "GL70", waste: "Recogida de vidrio" },
            { category: "Tapón", material: "Corcho", code: "FOR51", waste: "Orgánico" },
            { category: "Cápsula", material: "Aluminio", code: "ALU41", waste: "Recogida de metales" },
            { category: "Alambre", material: "Hierro", code: "FE40", waste: "Recogida de metales" }
        ]
    }
};

const EtichettaAlimentareBiunt = () => {
    const [lang, setLang] = useState("it");
    const [product] = useState(productData);

    // Funzione per ottenere i dati del prodotto tradotti
    const getTranslatedProduct = (language) => {
        return {
            ...product,
            affinamento: translations[language].affinamento,
            regione: translations[language].regione,
            paese: translations[language].paese,
            ingredients: product.ingredients[language]
        };
    };

    const translatedProduct = getTranslatedProduct(lang);

    return (
        <div className="bg-white flex flex-col items-center">
            <div className="w-full max-w-md px-4">
                <select
                    className="w-full border border-gray-300 rounded-md p-2 mb-4"
                    value={lang}
                    onChange={(e) => setLang(e.target.value)}
                >
                    {Object.entries(europeanLanguages).map(([code, label]) => (
                        <option key={code} value={code}>{label}</option>
                    ))}
                </select>
            </div>
            <div className="flex flex-col items-center justify-center text-center">
                <img src={translatedProduct.image} alt={translatedProduct.name} className="h-full max-h-[500px]" />
                <div className="mt-2 lg:mt-2 w-full">
                    <Info data={translatedProduct} lang={lang} />
                </div>
                <h1 className="text-2xl font-bold my-4 w-full">{translations[lang].ingredients}</h1>
                <p>{translatedProduct.ingredients}</p>
                <h1 className="text-2xl font-bold my-4 w-full">{translations[lang].nutrition}</h1>
                <NutritionalTable product={translatedProduct.nutritionalValues} lang={lang} />
                <h1 className="text-2xl font-bold my-4 w-full">{translations[lang].environment}</h1>
                <AmbientalTable product={translatedProduct.environmentalInfo[lang]} lang={lang} />
            </div>
        </div>
    );
};

export default EtichettaAlimentareBiunt;